import { BoardRoleEnum } from "enums/BoardRoleEnum";
import { useContext, useMemo } from "react";

import { PermissionsContext } from "./PermissionsContext";

export function usePermissions() {
  const { permissions, handleHttpError, setErrorCode } = useContext(PermissionsContext);

  const currentUserEmail = useMemo(() => `${permissions?.user?.email}`.toLowerCase(), [permissions]);
  const isAdministrator = useMemo(() => permissions?.isAdministrator || false, [permissions]);

  const isBoardOwner = useMemo(
    () => isAdministrator || (permissions?.boardRoles || []).filter((x) => x.role === BoardRoleEnum.Owner).length > 0,
    [isAdministrator, permissions]
  );

  const isBoardMember = useMemo(
    () => isAdministrator || (permissions?.boardRoles || []).filter((x) => x.role === BoardRoleEnum.Member).length > 0,
    [isAdministrator, permissions]
  );

  const showPermissions = useMemo(() => permissions?.showPermissions == true, [permissions]);

  return useMemo(
    () => ({
      permissions,
      currentUserEmail,
      isAdministrator,
      isBoardOwner,
      isBoardMember,
      setErrorCode,
      handleHttpError,
      showPermissions,
    }),
    [
      permissions,
      currentUserEmail,
      isAdministrator,
      isBoardOwner,
      isBoardMember,
      setErrorCode,
      handleHttpError,
      showPermissions,
    ]
  );
}
